export default "__VITE_ASSET__sKdB2UXr__"